import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import {
  GET_ORGANIZATIONS,
  GET_TAX_ID_NUMBERS,
  GET_PROVIDERS,
  GET_SAVED_PROVIDER,
  POST_SAVED_PROVIDER,
} from './constants';

const initialState = {
  organizations: [],
  corporates: [],
  taxIdNumbers: [],
  providers: [],
  savedProvider: {},
};

export const providersReducer = createReducer(initialState, {
  [`${GET_ORGANIZATIONS}_STARTED`]: () => {
    return {
      organizations: [],
      corporates: [],
      taxIdNumbers: [],
      providers: [],
    };
  },

  [`${GET_ORGANIZATIONS}_SUCCESS`]: (state, action) => {
    return {
      organizations: action.payload,
    };
  },

  [`${GET_TAX_ID_NUMBERS}_STARTED`]: () => {
    return {
      taxIdNumbers: [],
      providers: [],
    };
  },

  [`${GET_TAX_ID_NUMBERS}_SUCCESS`]: (state, action) => {
    return {
      taxIdNumbers: action.payload,
    };
  },

  [`${GET_PROVIDERS}_STARTED`]: () => {
    return {
      providers: [],
    };
  },

  [`${GET_PROVIDERS}_SUCCESS`]: (state, action) => {
    return {
      providers: action.payload,
    };
  },

  [`${GET_SAVED_PROVIDER}_SUCCESS`]: (state, action) => {
    return {
      savedProvider: action.payload,
    };
  },

  [`${GET_SAVED_PROVIDER}_ERROR`]: (state, action) => {
    return action.payload;
  },

  [`${POST_SAVED_PROVIDER}_SUCCESS`]: (state, action) => {
    return {
      savedProvider: action.payload,
    };
  },
});
